export default {
    USER_ID: `LmwjvQcuQUzjlxUyH`, //userID
    TEMPLATE_ID: `template_stage`,         //templateID
    TEMPLATE_CONTACTID:`template_contactstage`,
    TEMPLATE_CONFIRM:`template_confirm`,
    SERVICE_ID:`gmail_kandf`
    }